export function getSafeAuthRedirectPath(next: string | null | undefined, fallback = "/") {
  // Only same-origin paths. `//host` and `/\host` are both treated as
  // protocol-relative URLs by browsers, so they must be rejected too.
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) {
    return fallback;
  }

  return next;
}
